import {
  ReactivationPrefillResult,
  ReactivationPrefillSuccess,
  Typenames,
} from '@varo/graphql-schema-types';
import { format, parseISO } from 'date-fns';

export interface CustomerInfo {
  name: string;
  address: string;
  occupation: string;
  dateOfBirth: string;
  citizenship: string;
}

export function mapPrefillDataToCustomerInfo(
  prefill: ReactivationPrefillResult | null,
): CustomerInfo | null {
  if (prefill?.__typename !== Typenames.ReactivationPrefillSuccess) {
    return null;
  }

  const data = prefill as ReactivationPrefillSuccess;

  const name = `${data.name.first ?? ''} ${data.name.last ?? ''}`.trim();

  const address = Object.values(data.address ?? {})
    .filter(Boolean)
    .join(', ');

  const formatText = (text: string) =>
    text
      .replace(/_/g, ' ')
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');

  const occupation = formatText(data.occupation ?? '');

  const dateOfBirth = data.dateOfBirth
    ? format(parseISO(data.dateOfBirth), 'MM/dd/yyyy')
    : '';

  const citizenship = data.citizenship;

  return {
    name,
    address,
    occupation,
    dateOfBirth,
    citizenship,
  };
}
